import Link from "../link";

/**
 * A dictionary containing the API routes.
 * Contents: route name -\> route link.
 */

export class ApiRoutesDictionary {
    [key: string]: Link;
}
